module.exports = __webpack_public_path__ + "img/facebook.748d4b63.png";